export const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT || 'https://xver-api.xver.cloud';
export const KUFER_URL = process.env.REACT_APP_KUFER_URL || 'https://apis.xver.cloud/kufer';
export const SAMMELN_URL = process.env.REACT_APP_SAMMELN_URL || 'https://apis.xver.cloud/sammeln';
export const OMISE_PUBLIC_KEY = process.env.REACT_APP_OMISE_PKEY || 'pkey_test_5cq6bsnexpcagdh5m6o';
export const TURNSTILE_SITE_KEY =
    process.env.REACT_APP_TURNSTILE_SITE_KEY || '0x4AAAAAAB-BVXrd7g_iJgMw';
export const LIVE_CHAT_URL = process.env.REACT_APP_LIVE_CHAT_URL || '';
export const LIVE_CHAT_KEY = process.env.REACT_APP_LIVE_CHAT_KEY || '';
